<template>
  <div class="search-filter">
    <div class="filter-rows" v-if="deviceType !== 'mobile'">
      <div class="filter-row">
        <div class="filter-item">
          <div class="filter-label">Gender</div>
          <el-select v-model="filters.gender" class="filter-select" placeholder="Select"
            popper-class="filter-dropdown" multiple collapse-tags
            @change="handleSelectChange('gender')">
            <el-option v-for="item in genderOptions" :key="item.value" :label="item.label"
              :value="item.value" />
          </el-select>
        </div>
        <div class="filter-item">
          <div class="filter-label">A-Z</div>
          <el-select v-model="filters.letter" class="filter-select active" placeholder="Select"
            popper-class="filter-dropdown " multiple collapse-tags
            @change="handleSelectChange('letter')">
            <el-option v-for="item in azOptions" :key="item.value" :label="item.label"
              :value="item.value" />
          </el-select>
        </div>
        <div class="filter-item">
          <div class="filter-label">Style</div>
          <el-select v-model="filters.style" class="filter-select" placeholder="Select"
            popper-class="filter-dropdown">
            <el-option v-for="item in styleOptions" :key="item.value" :label="item.label"
              :value="item.value" />
          </el-select>
        </div>
      </div>
      <div class="filter-row">
        <div class="filter-item">
          <div class="filter-label">Meaning</div>
          <el-select v-model="filters.meaning" class="filter-select" placeholder="Select"
            popper-class="filter-dropdown" multiple collapse-tags
            @change="handleSelectChange('meaning')">
            <el-option v-for="item in meaningOptions" :key="item.value" :label="item.label"
              :value="item.value" />
          </el-select>
        </div>
        <div class="filter-item">
          <div class="filter-label">Syllables</div>
          <el-select v-model="filters.syllables" class="filter-select" placeholder="Select"
            popper-class="filter-dropdown">
            <el-option v-for="item in syllablesOptions" :key="item.value" :label="item.label"
              :value="item.value" />
          </el-select>
        </div>
        <div class="filter-item opacity-0"></div>
      </div>
    </div>
    <div class="filter-rows" v-else>
      <div class="filter-item">
        <div class="filter-label">Gender</div>
        <el-select v-model="filters.gender" class="filter-select" placeholder="Select"
          popper-class="filter-dropdown mmmmmm" multiple @change="handleSelectChange('gender')">
          <el-option v-for="item in genderOptions" :key="item.value" :label="item.label"
            :value="item.value" />
        </el-select>
      </div>
      <div class="filter-item">
        <div class="filter-label">A-Z</div>
        <el-select v-model="filters.letter" class="filter-select active" placeholder="Select"
          popper-class="filter-dropdown mmmmmm" multiple @change="handleSelectChange('letter')">
          <el-option v-for="item in azOptions" :key="item.value" :label="item.label"
            :value="item.value" />
        </el-select>
      </div>
      <div class="filter-item">
        <div class="filter-label">Style</div>
        <el-select v-model="filters.style" class="filter-select" placeholder="Select"
          popper-class="filter-dropdown mmmmmm">
          <el-option v-for="item in styleOptions" :key="item.value" :label="item.label"
            :value="item.value" />
        </el-select>
      </div>
      <div class="filter-item">
        <div class="filter-label">Meaning</div>
        <el-select v-model="filters.meaning" class="filter-select" placeholder="Select"
          popper-class="filter-dropdown mmmmmm" multiple @change="handleSelectChange('meaning')">
          <el-option v-for="item in meaningOptions" :key="item.value" :label="item.label"
            :value="item.value" />
        </el-select>
      </div>
      <div class="filter-item">
        <div class="filter-label">Syllables</div>
        <el-select v-model="filters.syllables" class="filter-select" placeholder="Select"
          popper-class="filter-dropdown mmmmmm">
          <el-option v-for="item in syllablesOptions" :key="item.value" :label="item.label"
            :value="item.value" />
        </el-select>
      </div>
    </div>
    <div class="filter-actions">
      <div class="generate-button" @mouseenter="isGenerateHovered = true"
        @mouseleave="isGenerateHovered = false" :class="{ 'hovered': isGenerateHovered }"
        @click="generateNames">
        <img src="@/assets/icons/generate_white.svg" alt="generate" class="generate-icon" />
        <span>Generate Names</span>
      </div>
      <div class="reset-button" @mouseenter="isResetHovered = true"
        @mouseleave="isResetHovered = false" :class="{ 'hovered': isResetHovered }"
        @click="resetFilters">
        <img src="@/assets/icons/reset-icon.svg" alt="reset" class="reset-icon" />
        <span>Reset</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'SearchFilter',
  props: {
    initialFilters: {
      type: Object,
      default: () => ({
        gender: ['all'],
        letter: ['all'],
        style: 'all',
        meaning: ['all'],
        syllables: 'all',
        origin: 'all'
      })
    }
  },
  data () {
    return {
      isGenerateHovered: false,
      isResetHovered: false,
      defaultFilters: {
        gender: ['all'],
        letter: ['all'],
        style: 'all',
        meaning: ['all'],
        syllables: 'all',
        origin: 'all'
      },
      filters: {
        gender: ['all'],
        letter: ['all'],
        style: 'all',
        meaning: ['all'],
        syllables: 'all',
        origin: 'all'
      },
      azOptions: [
        { value: 'all', label: 'All' },
        { value: 'A', label: 'A' },
        { value: 'B', label: 'B' },
        { value: 'C', label: 'C' },
        { value: 'D', label: 'D' },
        { value: 'E', label: 'E' },
        { value: 'F', label: 'F' },
        { value: 'G', label: 'G' },
        { value: 'H', label: 'H' },
        { value: 'I', label: 'I' },
        { value: 'J', label: 'J' },
        { value: 'K', label: 'K' },
        { value: 'L', label: 'L' },
        { value: 'M', label: 'M' },
        { value: 'N', label: 'N' },
        { value: 'O', label: 'O' },
        { value: 'P', label: 'P' },
        { value: 'Q', label: 'Q' },
        { value: 'R', label: 'R' },
        { value: 'S', label: 'S' },
        { value: 'T', label: 'T' },
        { value: 'U', label: 'U' },
        { value: 'V', label: 'V' },
        { value: 'W', label: 'W' },
        { value: 'X', label: 'X' },
        { value: 'Y', label: 'Y' },
        { value: 'Z', label: 'Z' }
      ],
      syllablesOptions: [
        { value: 'all', label: 'All' },
        { value: '1', label: '1' },
        { value: '2', label: '2' },
        { value: '3', label: '3' },
        { value: '4', label: '4' }
      ],
    };
  },
  computed: {
    ...mapGetters([
      'deviceType',
      'gender',
      'style',
      'meaning'
    ]),
    genderOptions () {
      if (!this.gender || this.gender.length === 0) return [{ value: 'all', label: 'All' }];
      return [{ value: 'all', label: 'All' }, ...this.gender.map(item => ({ label: item, value: item }))];
    },
    styleOptions () {
      if (!this.style || this.style.length === 0) return [{ value: 'all', label: 'All' }];
      return [{ value: 'all', label: 'All' }, ...this.style.map(item => ({ label: item, value: item }))];
    },
    meaningOptions () {
      if (!this.meaning || this.meaning.length === 0) return [{ value: 'all', label: 'All' }];
      return [{ value: 'all', label: 'All' }, ...this.meaning.map(item => ({ label: item, value: item }))];
    }
  },
  watch: {
    initialFilters: {
      handler (newVal) {
        if (newVal && Object.keys(newVal).length > 0) {
          this.filters = JSON.parse(JSON.stringify(newVal));
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    resetFilters () {
      this.filters = JSON.parse(JSON.stringify(this.defaultFilters));
    },
    handleSelectChange (filterType) {
      const selectedValues = this.filters[filterType];

      // The last selected item
      const lastSelection = selectedValues[selectedValues.length - 1];

      // If 'all' was already the only selection, and a new item is added
      if (selectedValues.length > 1 && selectedValues.includes('all')) {
        this.filters[filterType] = [lastSelection];
      }
      // If 'all' is selected along with other items
      else if (lastSelection === 'all') {
        this.filters[filterType] = ['all'];
      }
      // If the selection is cleared
      else if (selectedValues.length === 0) {
        this.filters[filterType] = ['all'];
      }
    },
    generateNames () {
      const queryParams = {};
      Object.keys(this.filters).forEach(key => {
        const value = this.filters[key];
        if (Array.isArray(value)) {
          if (value.length > 0 && !value.some(v => typeof v === 'string' && v.toLowerCase() === 'all')) {
            queryParams[key] = value;
          }
        } else {
          if (value && typeof value === 'string' && value.toLowerCase() !== 'all') {
            queryParams[key] = value;
          }
        }
      });
      this.$router.push({
        path: '/names',
        query: queryParams
      }).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          console.error(err);
        }
      });
    }
  },
  mounted () {
    // Rename filters.az to filters.letter to match the parameter name in names.vue
    if (this.filters.az) {
      this.filters.letter = this.filters.az;
      delete this.filters.az;
    }
    if (this.defaultFilters.az) {
      this.defaultFilters.letter = this.defaultFilters.az;
      delete this.defaultFilters.az;
    }
  }
};
</script>

<style lang="scss" >
@import '~@/css/variables.scss';
.el-select-dropdown__list {
	padding: rem(3) 0;
}
.el-select__tags {
	padding-left: 5px;
}
.el-select-dropdown__item {
	padding: 0 rem(3) !important;
}
.el-select-dropdown__item.selected {
	color: #a31984;
}
.el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
	background: rgba(163, 25, 132, 0.1);
}
.el-form {
	padding-bottom: 0;
}
.el-input__inner {
	border-radius: rem(20);
	border: rem(2) solid rgba(163, 25, 132, 0.1);
	background: #fff;
}
.el-range-editor.is-active,
.el-range-editor.is-active:hover,
.el-select .el-input.is-focus .el-input__inner {
	border-color: #a31984;
}
.el-input__inner:hover {
	border-color: rgba(163, 25, 132, 0.3);
}
.el-select:hover .el-input__inner {
	border-color: rgba(163, 25, 132, 0.3);
}
.el-select .el-input__inner:focus {
	border-color: #a31984;
}
.el-select__caret {
	color: #a31984 !important;
}
.sort-select {
	width: rem(140);
	.el-input__inner {
		border: none;
		color: #a31984;
		padding: 0 !important;
		font-size: rem(16);
		font-style: normal;
		font-weight: 700;
		line-height: rem(16); /* 100% */
		text-transform: capitalize;
	}
}
.el-select__tags {
	max-width: calc(100% - rem(30));
}
.el-tag {
	background-color: rgba(163, 25, 132, 0.1);
	border-color: rgba(163, 25, 132, 0.2);
	color: #a31984;
}
.el-tag .el-tag__close {
	color: #a31984;
}
.el-tag .el-tag__close:hover {
	background-color: #a31984;
	color: #fff;
}
.mmmmmm {
	.el-select-dropdown__item {
		font-size: rem(13);
		line-height: rem(34);
		height: rem(34);
		padding: 0 rem(10) !important;
	}
}
.detect_deviece_mobile {
	.el-input__inner {
		height: rem(60);
		padding: rem(18) rem(44) rem(18) rem(24);
		border-radius: rem(20);
		border: rem(2) solid rgba(163, 25, 132, 0.1);
		background: #fff;
		color: #03133a;
		font-size: rem(18);
		font-style: normal;
		font-weight: 700;
		line-height: rem(20); /* 111.111% */
		text-transform: capitalize;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		display: inline-block;
	}
	.el-input__suffix {
		right: rem(24);
	}
	.el-select__tags {
		padding-left: rem(15);
	}
	.el-select__caret {
		display: flex !important;
		align-items: center !important;
		justify-content: center !important;
	}

	.sort-select {
		.el-input__inner {
			border: none !important;
			border-radius: 0;
			color: #a31984;
			font-size: rem(16);
			font-style: normal;
			font-weight: 700;
			height: rem(16); /* 100% */
			line-height: rem(16); /* 100% */
			text-transform: capitalize;
		}
		.el-input__suffix {
			right: rem(8);
		}
		.el-select__caret {
			font-size: rem(16);
		}
	}
}
</style>
<style lang="scss" scoped>
@import '~@/css/variables.scss';

.search-filter {
	background: #f7f3f3;
	border-radius: rem(36);
	padding: rem(32);
	display: flex;
	flex-direction: column;
	gap: rem(48);
	align-items: flex-start;
	justify-content: flex-start;
	width: 100%;
	position: relative;

	.filter-rows {
		display: flex;
		flex-direction: column;
		gap: rem(24);
		align-items: flex-start;
		justify-content: flex-start;
		width: 100%;
		position: relative;

		.filter-row {
			display: flex;
			flex-direction: row;
			gap: rem(28);
			align-items: center;
			justify-content: flex-start;
			align-self: stretch;
			position: relative;
		}
	}

	.filter-actions {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		align-self: stretch;
		position: relative;

		.generate-button {
			background: #a31984;
			border-radius: rem(100);
			padding: rem(20) rem(32);
			display: flex;
			flex-direction: row;
			gap: rem(16);
			align-items: center;
			justify-content: center;
			width: rem(320);
			height: rem(60);
			position: relative;
			cursor: pointer;
			transition: all 0.3s ease;

			&.hovered {
				opacity: 0.8;
			}

			.generate-icon {
				width: rem(28);
				height: rem(28);
			}

			span {
				color: #ffffff;
				text-align: center;
				font-size: rem(22);
				line-height: rem(24);
				font-weight: 900;
				position: relative;
			}
		}

		.reset-button {
			border-radius: rem(100);
			border: rem(1) solid #a31984;
			display: flex;
			flex-direction: row;
			gap: rem(16);
			align-items: center;
			justify-content: center;
			width: rem(160);
			height: rem(60);
			position: relative;
			cursor: pointer;
			transition: all 0.3s ease;

			&.hovered {
				background: #a31984;

				span {
					color: #ffffff;
				}

				.reset-icon {
					filter: brightness(0) invert(1);
				}
			}

			.reset-icon {
				width: rem(20);
				height: rem(20);
			}

			span {
				color: #a31984;
				text-align: left;
				font-size: rem(20);
				line-height: rem(20);
				font-weight: 700;
				position: relative;
			}
		}
	}
}

.filter-item {
	display: flex;
	flex-direction: column;
	gap: rem(8);
	align-items: flex-start;
	justify-content: flex-start;
	flex: 1;
	position: relative;

	&.opacity-0 {
		opacity: 0;
	}

	.filter-label {
		padding: 0 rem(20);
		color: #03133a;
		text-align: left;
		font-size: rem(16);
		line-height: rem(16);
		font-weight: 400;
		position: relative;
	}

	:deep(.filter-select) {
		width: 100%;
		border-radius: rem(20);

		.el-input__wrapper {
			background: #ffffff;
			border-radius: rem(20);
			border: rem(2) solid rgba(163, 25, 132, 0.1);
			padding: rem(18) rem(24);
			box-shadow: none !important;
			height: rem(60);
			transition: all 0.3s ease;
			cursor: pointer;

			&:hover {
				border-color: rgba(163, 25, 132, 0.3);
			}

			&.is-focus {
				border-color: #a31984;
			}

			.el-input__inner {
				color: #03133a;
				font-size: rem(18);
				line-height: rem(20);
				font-weight: 700;
				height: 100%;
				max-width: calc(100% - rem(20));
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
			}
		}

		&.active .el-input__wrapper {
			border-color: #a31984;
		}

		.el-select__caret {
			color: #03133a;
			font-size: rem(18);
		}
	}
}

.detect_deviece_mobile {
	.search-filter {
		padding: rem(24) rem(16);
		gap: rem(24);

		.filter-rows {
			gap: rem(16);
		}

		.filter-actions {
			flex-direction: column;
			gap: rem(16);
			margin-top: rem(8);

			.generate-button,
			.reset-button {
				width: 100%;
			}
		}
	}

	.filter-item {
		width: 100%;
		:deep(.filter-select) {
			.el-input__inner {
				height: auto;
				min-height: rem(60);
				padding: rem(10) rem(44) rem(10) rem(24);
			}

			.el-select__tags {
				.el-tag {
					font-size: rem(14);
					margin: rem(4);
				}
			}
		}
	}
	.el-select__caret {
		display: flex !important;
		align-items: center !important;
		justify-content: center !important;
	}
}
</style> 